"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Our modal window module.
 *
 * A modal window is an application window that is designed to interrupt the
 * current processing of the application in order to prompt the user to enter
 * information (Basic modal dialog) or require a response (Alert modal dialog).
 */
var modal = {

  /**
   * Last element that had the focus when the modal has been opened.
   * @type {Object}
   */
  lastFocus: undefined,

  /**
   * Initiates the tracking of events related to the modal windows.
   * @return {[type]} [description]
   */
  init: function init() {

    document.addEventListener("focus", function (event) {

      var openedModal = document.querySelector(".modal.open");

      if (openedModal && !openedModal.contains(event.target)) {
        event.stopPropagation();
        this.openedModal.focus();
      }
    }, true);

    document.addEventListener("keydown", function (event) {

      var openedModal = document.querySelector(".modal.open");

      if (openedModal && event.keyCode == 27) {
        this.closeModal(openedModal);
      }
    }, true);

    this.trackModalToggle();
  },

  /**
   * Tracks for click of modal toggles to either open a modal or close it.
   */
  trackModalToggle: function trackModalToggle() {

    var link = void 0;
    var links = document.querySelectorAll('[data-toggle-modal]'),
        that = this,
        onClickHandler = function onClickHandler(event) {

      var openedDialog = document.querySelector(".modal.open");

      event.preventDefault();

      if (openedDialog) {
        that.closeModal(openedDialog);
      } else {
        that.openModal(this.getAttribute('data-toggle-modal'));
      }
    };

    for (var i = links.length - 1; i >= 0; i--) {
      link = links[i];
      link.onclick = onClickHandler;
    }
  },

  /**
   * Opens the modal that hold the given id.
   * @param  {String} id The modal id
   */
  openModal: function openModal(id) {
    var modal = document.getElementById(id);
    this.lastFocus = document.activeElement;
    modal.classList.toggle('open');
    modal.setAttribute('aria-hidden', 'false');
    modal.tabIndex = -1;
    modal.focus();
  },

  /**
   * Closes the given modal window.
   * @param  {Object} id The modal window.
   */
  closeModal: function closeModal(modal) {
    modal.classList.toggle('open');
    modal.setAttribute('aria-hidden', 'true');
    if (this.lastFocus) {
      this.lastFocus.focus();
    }
  }

};

exports.default = modal;